import CopyInput from './CopyInput.vue'

export default CopyInput
